import { useState, useEffect } from "react";
import { useStore } from "../contexts/StoreContext";
import { useQuery } from "@tanstack/react-query";
import { fetchStoreSetup } from "../api/queries";
import { useNavigate } from "react-router-dom";
import { getOnboardingPath, isOnboardingPath, isStartFlow } from "../utils/onboardingFlow";
import { returnedFromCheckout } from "../pages/start/checkout";

export const useSetupStatus = () => {
  const { selectedStore, canManageStore } = useStore();
  const navigate = useNavigate();
  const [setupCompleted, setSetupCompleted] = useState(false);

  const { data: setupStatus } = useQuery({
    queryKey: ["setup-status", selectedStore?.id],
    queryFn: () => fetchStoreSetup(selectedStore?.id),
    enabled: !!selectedStore?.id,
  });

  useEffect(() => {
    if (setupStatus) {
      const isComplete = setupStatus.setup_completed;

      setSetupCompleted(isComplete);

      // Every setup step (card, form, flyer, subscription) is admin-only on
      // the API, so a member of an unfinished store is not sent there — it
      // would be a page of 403s, and /setup redirects them straight back.
      // People who came in through /start finish there instead of /setup.
      // One who has just paid through /start is let in while Stripe's webhook
      // is still on its way: sending them back would only loop to Done.
      if (
        canManageStore &&
        !isComplete &&
        !isOnboardingPath(window.location.pathname) &&
        !(isStartFlow() && returnedFromCheckout(""))
      ) {
        navigate(getOnboardingPath());
      }
    }
  }, [setupStatus, canManageStore, navigate]);

  // For a member the store is as set up as it will get; show them the app.
  return setupCompleted || !canManageStore;
};
